export default __webpack_public_path__ + "2H1YeD6-fileshare.svg";